export default "__VITE_ASSET__297354ed__"